import Document, {Head, Main, NextScript} from 'next/document'
import { ServerStyleSheet, createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
	html {
	    margin: 0;
	    @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,500,600');
	    @import url('https://fonts.googleapis.com/css?family=PT+Serif:400i');
	    @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600,700');
	}
	
	body {
	    margin: 0;
	    font-family: 'Source Sans Pro', sans-serif;
	}
	
	i {
	    font-family: 'PT Serif', serif;
	}
	
	a {
	    color: #0e0e0e;
	    text-decoration: none;
	}
`

export default class MyDocument extends Document {
	static async getInitialProps (ctx) {
		const sheet = new ServerStyleSheet()

		const originalRenderPage = ctx.renderPage
		ctx.renderPage = () => originalRenderPage({
			enhanceApp: App => props => sheet.collectStyles(<App {...props} />)
		})

		const initialProps = await Document.getInitialProps(ctx)
		return { ...initialProps, styles: [...initialProps.styles, ...sheet.getStyleElement()] }
	}

	render() {
		return (
			<html>
				<Head>
					<meta name="viewport" content="initial-scale=1.0, width=device-width" key="viewport" />
					<GlobalStyle />
					{this.props.styleTags}
				</Head>
				<body>
					<Main />
					<NextScript />
				</body>
			</html>

		)
	}
}
